import React from "react";
import { styled } from "styled-components";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import Heading from "../../components/Layout/Heading";
import { OuterContainerStyles } from "../../components/Layout/Typography";
import Button from "../../components/Layout/Button";
import BasicDatePicker from "../../components/DatePicker/BasicDatePicker";
import BasicTimePicker from "../../components/TimePicker";

const TickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  padding: 24px;
`;
const TickerTextContainer = styled.div`
  display: flex;
  gap: 100px;
`;
const DateContainer = styled.div`
  display: flex;
  padding: 24px;
  justify-content: space-between;
`;
const ShowIn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
`;
const Text = styled.p`
  color: #484848;
  font-size: 16px;
  font-weight: 400;
  margin: 0 0;
`;
const CheckboxContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  padding: 24px;
`;
function MessageTicker() {
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <PageSyncCal />
      <Heading title="Message Ticker" />
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <TickerContainer>
          <TickerTextContainer>
            <Text>Ticker Text</Text>
            <textarea
              placeholder="Add Ticker Text Here"
              style={{ height: "100px" }}
            />
          </TickerTextContainer>
        </TickerContainer>
        <DateContainer>
          <div style={{ display: "flex", gap: "100px" }}>
            <Text>Date(From)</Text>
            {/* <CustomDatePicker/> */}
            <BasicDatePicker useDefaultBorders />
          </div>
          <div style={{ display: "flex", gap: "100px" }}>
            <Text>Time</Text>
            {/* <CustomDatePicker/> */}
            {/* <BasicDatePicker useDefaultBorders={true}/> */}
            <BasicTimePicker />
          </div>
        </DateContainer>
        <DateContainer>
          <div style={{ display: "flex", gap: "120px" }}>
            <Text>Date(To)</Text>
            {/* <CustomDatePicker/> */}
            <BasicDatePicker useDefaultBorders />
          </div>
          <div style={{ display: "flex", gap: "100px" }}>
            <Text>Time</Text>
            {/* <CustomDatePicker/> */}
            <BasicTimePicker />
          </div>
        </DateContainer>
        <ShowIn>
          <Text>Show In</Text>
          <CheckboxContainer>
            <FormControlLabel control={<Checkbox />} label="Area Login" />
            <FormControlLabel control={<Checkbox />} label="Zone Login" />
            <FormControlLabel control={<Checkbox />} label="Region Login" />
            <FormControlLabel control={<Checkbox />} label="Chapter Login" />
            <FormControlLabel control={<Checkbox />} label="District Login" />
          </CheckboxContainer>
        </ShowIn>
        <ButtonContainer>
          <Button cancel>Cancel</Button>
          <Button>Submit</Button>
        </ButtonContainer>
      </OuterContainerStyles>
    </div>
  );
}

export default MessageTicker;
